export default __webpack_public_path__ + "static/media/EM1840.34I-42126_-25317_0.e66e8e31.jpg";